/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

// Use this file to export global export constants in SCREAMING_SNAKE_CASE;
export const PAYMENT_RECEIVED_DATE_TRANSACTIONS = [
  '01',
  '03',
  '04',
  '05',
  '07',
  '08',
  '11',
  '12',
  '13',
  '14',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '26',
  '2B',
  '2C',
  '2H',
  '2K',
  '2P',
  '2Y',
  '2Z',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '88',
  '8B',
  '8C',
  '8H',
  '8K',
  '8P',
  '90',
  'MP',
];

// Servicing status codes used for PIF/foreclosure-related transaction handling.
// These values come from the loan's servStatus and represent the loan's current servicing status.
export const PIF_FORECLOSURE_STATUSES = ['PIF', 'FSS', 'FST', 'FCJ', 'FCL', 'FSB', 'FSC', 'FSD', 'FCR', 'FCS'];

// Collection status codes used when a loan is already PIF to identify how the loan was resolved.
// These values come from collectionStatus and suppress the 'Congratulations!' message for foreclosure, deed-in-lieu, and short-sale dispositions.
export const NON_CONGRATULATORY_PIF_COLLECTION_STATUSES = [
  'FC', // Foreclosure
  'DL', // Deed in Lieu
  'SS', // Short Sale
];

export const SUFFIX_TRANSACTIONS = [
  '01',
  '05',
  '07',
  '08',
  '11',
  '12',
  '13',
  '14',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '26',
  '28',
  '2B',
  '2C',
  '2H',
  '2K',
  '8H',
  '8B',
  '8C',
  '8K',
  '2P',
  '2Y',
  '2Z',
  '31',
  '32',
  '34',
  '35',
  '36',
  '38',
  '40',
  '42',
  '46',
  '48',
  '49',
  '50',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '72',
  '73',
  '74',
  '75',
  '80',
  '82',
  '84',
  '86',
  '88',
  'TX',
  'HA',
  'GR',
  'HZ',
  'MI',
  'MP',
];
export const PAYMENT_AMOUNT_TRANSACTIONS = [
  '05',
  '07',
  '08',
  '11',
  '13',
  '14',
  '16',
  '17',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '26',
  '27',
  '28',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '44',
  '45',
  '46',
  '48',
  '49',
  '50',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '72',
  '74',
  '75',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '88',
  '90',
  '2B',
  '2C',
  '2H',
  '2K',
  '2P',
  '2Q',
  '2Y',
  '2Z',
  '8B',
  '8C',
  '8H',
  '8K',
  '8P',
  'TX',
  'HA',
  'GR',
  'HZ',
  'MI',
  'MP',
];
export const SUBSIDY_TRANSACTIONS = ['2Q'];
export const PRINCIPAL_TRANSACTIONS = ['01', '07', '18', '29'];
export const INTEREST_TRANSACTIONS = ['01', '07', '18', '29'];
export const PRINCIPAL_CURTAIL_TRANSACTIONS = ['05', '07', '08', 'MP'];
export const ESCROW_TRANSACTIONS = ['01', '05', '07', '08', '18', '29', 'MP'];
export const LATE_CHARGE_TRANSACTIONS = ['05', '07', '08', '18', '29', 'MP'];
export const CORPORATE_ADVANCE_TRANSACTIONS = ['05', '07', '08', '18', '29', 'MP'];
export const ASSESSMENT_TRANSACTIONS = ['05', '07', '08', '18', '29', 'MP'];
export const SUSPENSE_TRANSACTIONS = ['01', '05', '07', '08', '11', '13', '14', '17', '20', '23', '24', '26', 'MP'];
export const TOTAL_TRANSACTIONS = [
  'PAYMENT_AMOUNT_TRANSACTIONS',
  'PRINCIPAL_TRANSACTIONS',
  'INTEREST_TRANSACTIONS',
  'PRINCIPAL_CURTAIL_TRANSACTIONS',
  'ESCROW_TRANSACTIONS',
  'LATE_CHARGE_TRANSACTIONS',
  'CORPORATE_ADVANCE_TRANSACTIONS',
  'ASSESSMENT_TRANSACTIONS',
  'SUSPENSE_TRANSACTIONS',
];
export const CHECK_NUMBER_TRANSACTIONS = [
  '05',
  '07',
  '08',
  '11',
  '12',
  '13',
  '14',
  '16',
  '17',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '26',
  '2B',
  '2C',
  '2H',
  '2K',
  '2P',
  '2Y',
  '2Z',
  '31',
  '32',
  '34',
  '35',
  '36',
  '38',
  '40',
  '42',
  '44',
  '45',
  '46',
  '48',
  '49',
  '50',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '72',
  '73',
  '74',
  '75',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '88',
  '8B',
  '8C',
  '8H',
  '8K',
  '8P',
  '90',
  'TX',
  'HA',
  'GR',
  'HZ',
  'MI',
  'MP',
];
export const FEE_NO_TRANSACTIONS = ['19', '20', '26', '88'];
export const FEE_CNT_TRANSACTIONS = ['19', '20', '26', '88'];
export const IMPOUND_TRANSACTIONS = [
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '44',
  '45',
  '46',
  '48',
  '49',
  '50',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '71',
  '72',
  '73',
  '74',
  '75',
  'TX',
  'HA',
  'GR',
  'HZ',
  'MI',
];
export const MULTIPLE_DESCRIPTION_TRANSACTIONS = ['13', '19', '22', '26', '28', '2H', '80', '84', '86', '88', '8H'];
export const REASON_TRANSACTIONS = ['18'];
export const TAX_NO_TRANSACTIONS = [
  'TX',
  'HA',
  'GR',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '46',
  '48',
  '49',
  '50',
];
export const UNIT_NO_TRANSACTIONS = ['HZ', 'MI', '61', '62', '63', '64', '65', '66', '67', '68', '69'];
export const POLICY_NO_TRANSACTIONS = ['HZ', 'MI', '61', '62', '63', '64', '65', '66', '67', '68', '69'];
export const RENEWAL_DATE_TRANSACTIONS = [
  'TX',
  'HA',
  'GR',
  'HZ',
  'MI',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '46',
  '48',
  '49',
  '50',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '72',
  '73',
  '74',
  '75',
];
export const PAYEE_TRANSACTIONS = [
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '46',
  '48',
  '49',
  '50',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '88',
  '8B',
  '8C',
  '8H',
  '8K',
  '8P',
  '90',
  'TX',
  'HA',
  'GR',
];
export const PAYEE2_TRANSACTIONS = ['80', '81', '82', '83', '84', '85', '86', '88', '8B', '8C', '8H', '8K', '8P', '90'];
export const PAYEE3_TRANSACTIONS = ['80', '81', '82', '83', '84', '85', '86', '88', '8B', '8C', '8H', '8K', '8P', '90'];
export const SALE_TRANSFER_TRANSACTIONS = ['27'];
export const MORTGAGE_PAYMENT_TRANSACTIONS = ['05', '07', '08', 'MP'];
export const EXCESS_FUNDS_TRANSACTIONS = ['05', '07', '08', 'MP'];
export const TAX_DISBURSEMENT_CODES = [
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '44',
  '45',
  '46',
  '48',
  '49',
  '50',
];
/** SQC-566: Posting codes for HOA / Ground Rent impounds used with master impound `/live/master/impound/{HA|GR}`. */
export const HOA_DISBURSEMENT_CODES = ['50'];
export const GROUND_RENT_DISBURSEMENT_CODES = ['46'];
/** SQC-566: Synthetic batch dropdown types that share the parcel-line disbursement workflow in Payments. */
export const PARCEL_LINE_BATCH_TYPES = ['TX', 'HA', 'GR'] as const;

export type ParcelLineBatchType = (typeof PARCEL_LINE_BATCH_TYPES)[number];

export const HAZARD_INSURANCE_CODES = ['61', '62', '63', '64', '65', '66', '67', '68', '69'];
export const MORTGAGE_INSURANCE_PREMIUM_CODES = ['72', '73', '74', '75'];
export const UNUSED_CODES = ['03', '04', '0A', '12', '29', '71', '99', 'RPS', 'UNK'];
export const UNUSED_SUFFIXES = ['C', 'F', 'G', 'M', 'T', 'V', 'W'];
export const LOAN_PAYMENT_CODES = [
  '05',
  '08',
  '16',
  '17',
  '20',
  '21',
  '22',
  '23',
  '24',
  '26',
  '2B',
  '2C',
  '2H',
  '2K',
  '2Y',
  '2Z',
  '2P',
  '11',
  '13',
  '14',
];
export const ROW_TOTAL_TRANSACTIONS = ['18'];
export const TR_TYPE_TRANSACTIONS = [
  'TX',
  'HA',
  'GR',
  'HZ',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '39',
  '40',
  '42',
  '44',
  '45',
  '46',
  '48',
  '49',
  '50',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
];
export const ALL_TRANSACTIONS = {
  PAYMENT_RECEIVED_DATE_TRANSACTIONS,
  SUFFIX_TRANSACTIONS,
  PAYMENT_AMOUNT_TRANSACTIONS,
  PRINCIPAL_TRANSACTIONS,
  INTEREST_TRANSACTIONS,
  PRINCIPAL_CURTAIL_TRANSACTIONS,
  ESCROW_TRANSACTIONS,
  LATE_CHARGE_TRANSACTIONS,
  CORPORATE_ADVANCE_TRANSACTIONS,
  ASSESSMENT_TRANSACTIONS,
  SUSPENSE_TRANSACTIONS,
  ROW_TOTAL_TRANSACTIONS,
  TOTAL_TRANSACTIONS,
  CHECK_NUMBER_TRANSACTIONS,
  FEE_NO_TRANSACTIONS,
  FEE_CNT_TRANSACTIONS,
  IMPOUND_TRANSACTIONS,
  MULTIPLE_DESCRIPTION_TRANSACTIONS,
  REASON_TRANSACTIONS,
  TAX_NO_TRANSACTIONS,
  UNIT_NO_TRANSACTIONS,
  POLICY_NO_TRANSACTIONS,
  RENEWAL_DATE_TRANSACTIONS,
  PAYEE_TRANSACTIONS,
  PAYEE2_TRANSACTIONS,
  PAYEE3_TRANSACTIONS,
  SALE_TRANSFER_TRANSACTIONS,
  MORTGAGE_PAYMENT_TRANSACTIONS,
  SUBSIDY_TRANSACTIONS,
};
export const TRANSACTION_PROPERTIES = {
  PAYMENT_RECEIVED_DATE_TRANSACTIONS: {
    dateReceived: (item) => item.dateReceived,
  },
  SUFFIX_TRANSACTIONS: { mcdTransSuffix: (item) => item.mcdTransSuffix },
  MULTIPLE_DESCRIPTION_TRANSACTIONS: {
    description: (item) => item.description,
  },
  PAYMENT_AMOUNT_TRANSACTIONS: {
    amount: (item) => (item.amount || '').toString(),
  },
  PRINCIPAL_TRANSACTIONS: {
    principalReqstd: (item) => (item.principalReqstd || '').toString(),
  },
  INTEREST_TRANSACTIONS: {
    interestReqstd: (item) => (item.interestReqstd || '').toString(),
  },
  PRINCIPAL_CURTAIL_TRANSACTIONS: {
    prinCurtailReqstd: (item) => (item.prinCurtailReqstd || '').toString(),
  },
  ESCROW_TRANSACTIONS: {
    extraEscrowReqstd: (item) => (item.extraEscrowReqstd || '').toString(),
  },
  LATE_CHARGE_TRANSACTIONS: {
    lateChargeReqstd: (item) => (item.lateChargeReqstd || '').toString(),
  },
  CORPORATE_ADVANCE_TRANSACTIONS: {
    corpAdvanceReqstd: (item) => (item.corpAdvanceReqstd || '').toString(),
  },
  ASSESSMENT_TRANSACTIONS: {
    assessmentsReqstd: (item) => (item.assessmentsReqstd || '').toString(),
  },
  SUSPENSE_TRANSACTIONS: {
    suspenseReqstd: (item) => (item.suspenseReqstd || '').toString(),
  },
  ROW_TOTAL_TRANSACTIONS: { amount: (item) => (item.amount || '').toString() },
  CHECK_NUMBER_TRANSACTIONS: { checkNo: (item) => item.checkNo },
  RENEWAL_DATE_TRANSACTIONS: { renewalDate: (item) => item.renewalDate },
  TAX_NO_TRANSACTIONS: { parcelId: (item) => item.parcelId },
  UNIT_NO_TRANSACTIONS: { unitNo: (item) => item.unitNo },
  POLICY_NO_TRANSACTIONS: { policyNo: (item) => item.policyNo },
  FEE_NO_TRANSACTIONS: { feeNo: (item) => item.feeNo },
  FEE_CNT_TRANSACTIONS: { feeCnt: (item) => item.feeCnt },
  IMPOUND_TRANSACTIONS: {
    impGroup: (item) => item.impGroup,
    impType: (item) => item.impType,
    assessorCode: (item) => item.assessorCode,
  },
  PAYEE_TRANSACTIONS: { payee: (item) => item.payee },
  PAYEE2_TRANSACTIONS: { payeeTwo: (item) => item.payeeTwo },
  PAYEE3_TRANSACTIONS: { payeeThree: (item) => item.payeeThree },
  SALE_TRANSFER_TRANSACTIONS: {
    from: (item) => item.from,
    to: (item) => item.to,
    groupCode: (item) => item.groupCode,
  },
  SUBSIDY_TRANSACTIONS: {
    subsidyName: (item) => item.subsidyName,
    subsidyCnt: (item) => item.subsidyCnt,
  },
};

export const SINGLE_TAB_COOKIE = 'siteOpen';

export const ANNUAL_TAX_STMT_1098 = 'ANNUAL_TAX_STATEMENT_FORM_1098';
export const ANNUAL_TAX_STMT_1098_REV = 'ANNUAL_TAX_STATEMENT_FORM_1098_REV';
export const ANNUAL_TAX_STMT_1099_INT = 'ANNUAL_TAX_STATEMENT_FORM_1099_INT';
export const ANNUAL_TAX_STMT_1099_INT_REV = 'ANNUAL_TAX_STATEMENT_FORM_1099_INT_REV';
export const ANNUAL_TAX_STMT_1099_A = 'ANNUAL_TAX_STATEMENT_FORM_1099_A';
export const ANNUAL_TAX_STMT_1099_A_REV = 'ANNUAL_TAX_STATEMENT_FORM_1099_A_REV';
export const ANNUAL_TAX_STMT_1099_C = 'ANNUAL_TAX_STATEMENT_FORM_1099_C';
export const ANNUAL_TAX_STMT_1099_C_REV = 'ANNUAL_TAX_STATEMENT_FORM_1099_C_REV';
export const ANNUAL_TAX_STATEMENT_PR_480_7A = 'ANNUAL_TAX_STATEMENT_FORM_PR_480_7A';
export const ANNUAL_TAX_STATEMENT_PR_480_7A_REV = 'ANNUAL_TAX_STATEMENT_FORM_PR_480_7A_REV';
export const IRS_1040_VALID_DOC_TYPES = [
  ANNUAL_TAX_STMT_1098,
  ANNUAL_TAX_STMT_1098_REV,
  ANNUAL_TAX_STMT_1099_INT,
  ANNUAL_TAX_STMT_1099_INT_REV,
  ANNUAL_TAX_STMT_1099_A,
  ANNUAL_TAX_STMT_1099_A_REV,
  ANNUAL_TAX_STMT_1099_C,
  ANNUAL_TAX_STMT_1099_C_REV,
  ANNUAL_TAX_STATEMENT_PR_480_7A,
  ANNUAL_TAX_STATEMENT_PR_480_7A_REV,
];
export const STATE_COLLECTION_LAWS = {
  MA: [
    {
      requirements: [
        'You may only call the Cell or Home number twice in a week.',
        'You may only call the Work number twice every 30 days unless the borrower requests you to call.',
        'While Skip Tracing, you may only call a number the borrower did not provide, twice every 30 days.',
        'Written Authorization required to discuss the loan with the spouse.',
      ],
      title: 'State Specific Collection Law for Massachusetts',
    },
  ],
  NH: [
    {
      requirements: [
        'Do not call the work number unless you have attempted to call the home/cell numbers in the last week.',
        'You may only call the Work number once every 30 days unless the borrower authorizes you to call.',
        "You require a written authorization to discuss the loan with the borrower's spouse.",
      ],
      title: 'State Specific Collection Law for New Hampshire',
    },
  ],
  NY: [
    {
      requirements: ['Do not call more than 3 times within a seven day consecutive calendar period.'],
      title: 'State Specific Collection Law for New York',
    },
  ],
  OR: [
    {
      requirements: [
        'You may only call the work number after you have made an attempt to contact the borrower at home/cell between 6PM-9PM in the last week.',
        'You may only call the Work number once every 7 days unless the borrower provides written authorization to call.',
      ],
      title: 'State Specific Collection Law for Oregon',
    },
  ],
  WA: [
    {
      requirements: [
        'Do not call more than 3 times a week unless the borrower is responding.',
        'Do not call employed more than one time per week.',
      ],
      title: 'State Specific Collection Law for Washington',
    },
  ],
};
export const STATE_LICENSING_REQUIREMENTS = {
  NY: [
    {
      requirements: [
        'This property is in the state of New York.',
        'Loan Servicing Representatives in the Puerto Rico Branch are not licensed to Service this loan.',
      ],
      title: 'State Licensing Requirement for New York',
    },
  ],
};
export const LOAN_FORM_FIELDS_TO_KEEP = [
  'mailingState',
  'loanNumber',
  'b1FirstName',
  'b1LastName',
  'mailingAddress',
  'mailingUnitNumber',
  'mailingCity',
  'mailingZipCode',
  'interestRate',
  'lpi',
  'closingDate',
  'loanAmount',
  'loanTerm',
  'firstPaymentDate',
  'apprReqAmt',
  'amortizationTerm',
  'fundingDate',
  'upfrontMIP',
  'latechrgtype',
  'loanPurposeDescription',
  'collectionStatus',
  'gracePer',
  'bankruptcyChap',
  'payHistory',
  'occupancy',
  'uwCreditGrade',
  'disasterName',
  'purchasePrice',
  'suppressNotice',
  'PIFReason',
  'assumable',
  'propertyNumUnits',
  'balloonPayment',
  'prepaymentPenalty',
  'pmtClctFreqDescription',
  'hpml',
  'loanConforming',
  'originationType',
  'loanTypeDescription',
  'interviewerUid',
  'mersId',
  'alternateLoanNumber',
  'investorCompanyCode',
  'escHoldAmount',
  'buyCommitmentNo',
  'sellCommitNo',
  'escrowDeposit',
  'maxIncomeFico',
  'contractNo',
  'discountPoints',
  'prePaidInterest',
  'servicingStopCodes',
  'agencyCaseNumber',
  'initAdvance',
  'earlyTerminationFee',
  'interestLifeCap',
  'lifeFloor',
  'margin',
  'mortNoteDt',
  'interestOnlyPeriod',
  'directlyPaidAmount',
  'estimatedClosingCosts',
  'closingCostsPaidInAdvance',
  'loanHeloc',
  'loanFha',
  'loanVa',
  'loanUsda',
  'ddrReason',
  'foreclosureMainStatus',
  'lateChargeAmt',
  'lteChrg',
  'propTypeDescription',
  'creditFunded',
  'lateChrgMin',
  'origLoanBalance',
];
export const LOAN_FORM_EVENT_DATE_CODES = [
  'SRG',
  'AEA',
  'SRM',
  'V04',
  'S7B',
  'S7A',
  'S79',
  'S78',
  'OSV',
  'F60',
  'PRI',
  'DFL',
  'ASD',
  'MCD',
  'MOE',
  'SRC',
  'SDT',
  'C06',
  'SER',
  'TPP',
  'TE1',
  'DTM',
  'FDS',
  'DAX',
  'DAK',
];
export const LOAN_FORM_RELATIONSHIP_CODES = [
  'FA',
  'MO',
  'FL',
  'ML',
  'SP',
  'SN',
  'DT',
  'FR',
  'CO',
  'AT',
  'FI',
  'FE',
  'HC',
  'LW',
  'TE',
];
export const OUTBOUND_CALL_CODES = ['C1', 'C2', 'C3', 'C4', 'C5', 'CO'];
export const CONTACT_RESULT_CODES = ['CA', 'CB', 'CC', 'CS'];
export const UPCOMING_PAYMENT_TRANSACTION_CODES = new Set([
  '05', // Mortgage Payment
  '08', // Mortgage Payment (Exception)
  '11', // Principal Only
  '13', // Escrow Only
  '14', // Late Charge
  '16', // Regular Suspense
  '19', // Assess/Waive Assessment Fee
  '20', // Assessment Fee Paid
  '21', // Buydown Funds
  '22', // Invoice Suspense
  '26', // Pay/Waive Corporate Advance
]);
